import { render, staticRenderFns } from "./BaseAlerts.vue?vue&type=template&id=9e0ccc8c&"
import script from "./BaseAlerts.vue?vue&type=script&lang=js&"
export * from "./BaseAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports